import React, { Component } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Toast from "../comps/alertMessage";
import * as aserver from '../../APIClient';
import * as utils from "../../Utilities";
import AlertModal from "../comps/alertModal";
import PolicyList from "../comps/policyList";
import CoachQuestions from "../comps/coachQuestions";
import { PasswordDiv, HandlePasswordEditChange } from "../../Utilities";
import LoadingBackdrop from '../comps/loadingBackdrop';
import Modal from '../comps/modal';
import { isMobile } from 'react-device-detect';
import Switch from '@material-ui/core/Switch';
import EditIcon from '@material-ui/icons/Edit';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import downloadIcon from '../images/BlueDownload.png'
import blueCopyIcon from '../images/Duplicate-blue.png'


const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 36,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    overflow: 'hidden',
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height:isMobile? 'calc(78vh - 64px)':'calc(91vh - 64px)'
  },
}));

// eslint-disable-next-line 
class UserProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: localStorage.getItem('Id'),
      password: "",
      isAdmin: "",
      name: "",
      surname: "",
      email: "",
      businessName: "",
      phone: "",
      companyRegNumber: "",
      vatNumber: "",
      postalAddress: "",
      level: "",
      message: "",
      confirmPassword: "",
      singleNotification: 0,
      bulkNotification: 0,
      teamReportNotification: 0,
      copyIntoClientEmails: 0,
      extraNotificationRecipients: "",
      error: [],
      success: [],
      confirmPasswordSuccess: [],
      confirmPasswordError: [],
      passwordGoodToGo: true,
      enableWebProfile: false,
      currentPassword: "",
      webProfileEmail: "",
      webProfilePhoneNumber: "",
      webProfileCountry: "",
      webProfileScopeOfPractice: "",
      webProfileSpecialization: "",
      webProfileCity: "",
      webProfileWorkOnline: false,
      failedMessage: "",
      openAlertModal: false,
      disableUpdateButton: false,
      openBackdrop:false,
      webProfileLanguages:"",
      webProfileSync:false,
      addAssistantModal:false,
      openCoachQuestionsModal:false,
      coachQuestionnaireCompleted:false,
      deleteConfirmModal:false,
      deleteAssistantUUID:"",
      deleteAssistantDisplayName:"",
      listOfAssistants:[],
      isBeingAssisted:localStorage.getItem("isBeingAssisted")==="true"?true:false,
      loggedInAssistantEmail: localStorage.getItem("assistantEmail"),
      accreditations: [],
      onlyMiniAssessment : false,
      twoFactorEnabled: false,
      authentication:"",
      invalidEmailAddress:false,
      webProfileWebSite:"",
      closeModalCallback:this.closeModal,
      originalProfile: {}, 
      hasChanges: false,
    };
  }

  listAssistants = async (id) => {
    let result = await aserver.get(`api/v2/coaches/${id}/assistants`);
    this.setState({listOfAssistants: result.data})
  }

  handleToggleBlock = async(assistantUUID, action) => {
    this.setState(prevState => ({
      listOfAssistants: prevState.listOfAssistants.map(info => {
        if (info.uuid === assistantUUID) {
          return {
            ...info,
            isBlocked: action === 'block', // Update the local state based on the action
          };
        }
        return info;
      }),
    }));
    let toggle = await aserver.get(`api/v2/coaches/${this.state.id}/assistantBlock/${assistantUUID}/${action}`)
    if (toggle.status !== 200) {
      this.openAlertModal("Failed", toggle.data.error.info)
    }
  };

fetchCoach = async () => {
  const { id } = this.state;
  let result = await aserver.get(`api/v2/coaches/${id}`);
  this.listAssistants(id);

  const formattedExtraEmails = result.data.extraNotificationRecipients
    ? result.data.extraNotificationRecipients.split(',').map(item => item.trim()).join("\n")
    : "";

  const fetchedProfile = {
    id,
    registerUUID: result.data.registerUUID,
    name: result.data.name,
    surname: result.data.surname,
    email: result.data.email,
    businessName: result.data.businessName,
    phone: result.data.phoneNumber,
    postalAddress: result.data.postalAddress,
    vatNumber: result.data.vatNumber,
    companyRegNumber: result.data.companyRegNumber,
    singleNotification: result.data.sendSingleAssessmentNotifications,
    bulkNotification: result.data.sendBulkAssessmentNotifications,
    teamReportNotification: result.data.sendTeamNotifications,
    copyIntoClientEmails: result.data.copyIntoClientEmails,
    extraEmails: formattedExtraEmails,
    webProfileEmail: result.data.webProfileEmail,
    webProfilePhoneNumber: result.data.webProfilePhoneNumber,
    webProfileCountry: result.data.webProfileCountry,
    webProfileCity: result.data.webProfileCity,
    webProfileWebSite: result.data.webProfileWebSite,
    webProfileLanguages: result.data.webProfileLanguages,
    enableWebProfile: result.data.webProfileSync === 0 ? false : true,
    webProfileWorkOnline: result.data.webProfileWorkOnline === 1 ? true : false,
    onlyMiniAssessment: result.data.onlyMiniAssessment === 1 ? true : false,
    isL1Conversionista: result.data.isL1Conversionista === 1 ? true : false,
    isGrantedLevel1: !!result.data.isGrantedLevel1,
    isAccreditedLevel1: !!result.data.isAccreditedLevel1,
    isGrantedLevel2: !!result.data.isGrantedLevel2,
    isAccreditedLevel2: !!result.data.isAccreditedLevel2,
    isGrantedLevel3: !!result.data.isGrantedLevel3,
    isAccreditedLevel3: !!result.data.isAccreditedLevel3,
    isGrantedLevel4: !!result.data.isGrantedLevel4,
    isAccreditedLevel4: !!result.data.isAccreditedLevel4,
    isGrantedLevel5: !!result.data.isGrantedLevel5,
    isAccreditedLevel5: !!result.data.isAccreditedLevel5,
    isGrantedLevel6: !!result.data.isGrantedLevel6,
    isAccreditedLevel6: !!result.data.isAccreditedLevel6,
    twoFactorEnabled: result.data.twoFactorEnabled === 1 ? true : false,
    password: "",
    confirmPassword: "",
    webProfileScopeOfPractice: result.data.webProfileScopeOfPractice || "",
    webProfileSpecialization: result.data.webProfileSpecialization || ""
  };

  this.setState({
    ...fetchedProfile,
    originalProfile: { ...fetchedProfile }
  });

  document.getElementById("webProfileScopeOfPractice").value = result.data.webProfileScopeOfPractice;
  document.getElementById("webProfileSpecialization").value = result.data.webProfileSpecialization;
};

  showToast = () => {
    this.setState(
      {
        showToast: true
      },
      () => {
        setTimeout(() => this.setState({ 
          showToast: false,
          disableUpdateButton:false 
        }), 2500);
      }
    );
  }

  success = () => {
    this.setState({
      modalIsOpen: false,
      message: "Successful",
      level: "success",
      openBackdrop:false,
    })
    this.showToast()
  }

  fail = (failureMessage) => {
    this.setState({
      modalIsOpen: false,
      message: failureMessage,
      level: "danger"
    })
    this.showToast()
  }

  closeModal = () => {
    this.setState({
      openAlertModal: false,
      openBackdrop:false,
      disableUpdateButton:false,
      addAssistantModal:false,
      assistantName:"",
      assistantSurname:"",
      assistantEmail:"",
      openEditModal:false,
    });
  }

  changeNumber = (e) =>{
    this.setState({ webProfilePhoneNumber: e })
  }

checkForChanges = () => {
  const {
    originalProfile,
    password,
    confirmPassword,
    currentPassword,
    name,
    surname,
    businessName,
    email,
    phone,
    postalAddress,
    companyRegNumber,
    vatNumber,
    singleNotification,
    bulkNotification,
    teamReportNotification,
    copyIntoClientEmails,
    enableWebProfile,
    webProfileWorkOnline,
    extraEmails,
    webProfileEmail,
    webProfileLanguages,
    webProfilePhoneNumber,
    webProfileCountry,
    webProfileCity,
    webProfileWebSite,
    webProfileScopeOfPractice,
    webProfileSpecialization,

  } = this.state;

  const currentProfile = {
    name: (name || "").trim(),
    surname: (surname || "").trim(),
    businessName: (businessName || "").trim(),
    email: (email || "").trim(),
    phone: (phone || "").trim(),
    postalAddress: (postalAddress || "").trim(),
    companyRegNumber: (companyRegNumber || "").trim(),
    vatNumber: (vatNumber || "").trim(),
    singleNotification,
    bulkNotification,
    teamReportNotification,
    copyIntoClientEmails,
    enableWebProfile,
    webProfileWorkOnline,
    password: (password || "").trim(),
    confirmPassword: (confirmPassword || "").trim(),
    currentPassword: (currentPassword || "").trim(),
    extraEmails: (extraEmails || "").trim(),
    webProfileEmail:(webProfileEmail|| "").trim(),
    webProfileLanguages:(webProfileLanguages|| "").trim(),
    webProfilePhoneNumber:(webProfilePhoneNumber|| "").trim(),
    webProfileCountry:(webProfileCountry|| "").trim(),
    webProfileCity:(webProfileCity|| "").trim(),
    webProfileWebSite:(webProfileWebSite|| "").trim(),
    webProfileScopeOfPractice:(webProfileScopeOfPractice|| "").trim(),
    webProfileSpecialization:(webProfileSpecialization|| "").trim(),
    profileImage: this.state.profileImage || null 
  };

  const normalizedOriginal = {
    name: (originalProfile.name || "").trim(),
    surname: (originalProfile.surname || "").trim(),
    businessName: (originalProfile.businessName || "").trim(),
    email: (originalProfile.email || "").trim(),
    phone: (originalProfile.phone || "").trim(),
    postalAddress: (originalProfile.postalAddress || "").trim(),
    companyRegNumber: (originalProfile.companyRegNumber || "").trim(),
    vatNumber: (originalProfile.vatNumber || "").trim(),
    singleNotification: originalProfile.singleNotification,
    bulkNotification: originalProfile.bulkNotification,
    teamReportNotification: originalProfile.teamReportNotification,
    copyIntoClientEmails: originalProfile.copyIntoClientEmails,
    enableWebProfile: originalProfile.enableWebProfile,
    webProfileWorkOnline: originalProfile.webProfileWorkOnline,
    password: "",
    confirmPassword: "",
    currentPassword: "",
    extraEmails: (originalProfile.extraEmails || "").trim(),
    webProfileEmail:(originalProfile.webProfileEmail|| "").trim(),
    webProfileLanguages:(originalProfile.webProfileLanguages|| "").trim(),
    webProfilePhoneNumber:(originalProfile.webProfilePhoneNumber|| "").trim(),
    webProfileCountry:(originalProfile.webProfileCountry|| "").trim(),
    webProfileCity:(originalProfile.webProfileCity|| "").trim(),
    webProfileWebSite:(originalProfile.webProfileWebSite|| "").trim(),
    webProfileScopeOfPractice:(originalProfile.webProfileScopeOfPractice|| "").trim(),
    webProfileSpecialization:(originalProfile.webProfileSpecialization|| "").trim(),
    profileImage: this.state.originalProfile.profileImage || null

  };

  const hasChanges =
    JSON.stringify(currentProfile) !== JSON.stringify(normalizedOriginal);

  this.setState({ hasChanges, disableUpdateButton: !hasChanges });
};



  handleChange = ({ target: { name, value, type } }) => {
    let invalidEmailAddress = this.state.invalidEmailAddress;
    if (type === "email") {
      invalidEmailAddress = !utils.validateEmail(value);
    }  

    this.setState(
      { [name]: value, invalidEmailAddress },
      () => this.checkForChanges()
    );
  }

  checkPreferences = (event) => {
    const { checked, name } = event.target;
    const value = checked ? 1 : 0;
    this.setState({ [name]: value }, () => this.checkForChanges());
    localStorage.setItem(name, value);
  }

  checkIfDisabled = (event) => {
    const { checked } = event.target;
    this.setState({ enableWebProfile: checked }, () => this.checkForChanges());
  }

  checkOnlinePreferences = (event) => {
    const { checked } = event.target;
    this.setState({ webProfileWorkOnline: checked }, () => this.checkForChanges());
  }


  validateExtraEmails() {
    // get emails, with all blank lines filtered out, with all whitespace before and each email trimmed off, and get into an array
    let extraEmails = document.getElementById('extraEmails').value.replace(this.state.email, "").split("\n").map(e => e.trim()).filter(e => e.length > 0);
    // get an array of all the invalid email addresses
    let invalidEmails = extraEmails.filter(e => !utils.validateEmail(e));
    // user input is valid if there are no invalid emails:
    let valid = invalidEmails.length === 0;
    // return emails as a CSV string
    return ([valid, extraEmails.join(","), invalidEmails.join(", ")]);
  }

  handleSubmit = async (event) => {
  event.preventDefault();
  this.setState({ disableUpdateButton: true });

  const {
    id, name, surname, businessName, email, password, confirmPassword,
    phone, companyRegNumber, vatNumber, postalAddress,
    singleNotification, bulkNotification, teamReportNotification, copyIntoClientEmails,
    passwordGoodToGo, currentPassword, enableWebProfile, webProfileWorkOnline,
    invalidEmailAddress
  } = this.state;

  let doesCurrentPasswordMatch;
  const doesNewPasswordsMatch = password === confirmPassword;

  if (invalidEmailAddress) {
    this.openAlertModal("Failed", "Update failed - your email is invalid");
    return;
  }

  const [emailsValid, extraEmailsCSVString, invalidEmailsCSVString] = this.validateExtraEmails();
  if (!emailsValid) {
    this.openAlertModal("Failed", `Invalid emails: ${invalidEmailsCSVString}`);
    return;
  }

  if (extraEmailsCSVString.length > 300) {
    alert("You cannot specify so many email recipients");
    return;
  }

  if (currentPassword !== "" && password !== "") {
    const checkRes = await aserver.post(`api/v2/coaches/${id}/checkPassword`, { password: currentPassword });
    doesCurrentPasswordMatch = checkRes.data.allowed;
  } else if (currentPassword === "" && password !== "") {
    doesCurrentPasswordMatch = false;
  } else {
    doesCurrentPasswordMatch = true;
  }

  var formData = new FormData(document.getElementById("webProfileForm"));
  formData.append('name', name);
  formData.append('surname', surname);
  formData.append('businessName', businessName);
  formData.append('email', email);
  formData.append('password', password);
  formData.append('phoneNumber', phone);
  formData.append('postalAddress', postalAddress);
  formData.append('companyRegNumber', companyRegNumber);
  formData.append('vatNumber', vatNumber);
  formData.append('sendSingleAssessmentNotifications', singleNotification);
  formData.append('sendBulkAssessmentNotifications', bulkNotification);
  formData.append('sendTeamNotifications', teamReportNotification);
  formData.append('copyIntoClientEmails', copyIntoClientEmails);
  formData.append('extraNotificationRecipients', extraEmailsCSVString.replace(email, ""));
  formData.append('webProfileSync', enableWebProfile);
  formData.append('webProfileWorkOnline', webProfileWorkOnline);

  if (passwordGoodToGo && doesCurrentPasswordMatch && doesNewPasswordsMatch) {
    this.setState({ disableUpdateButton: true, openBackdrop: true });
    let update = await aserver.put(`api/v2/coaches/${id}`, formData);

    if (update.status === 200) {
      this.success();
      localStorage.setItem("coachEmailAddress", email);
      this.props.profileChanged({ name, surname });

      const newProfile = {
        id, name, surname, businessName, email,
        password: "", confirmPassword: "", phone,
        companyRegNumber, vatNumber, postalAddress,
        singleNotification, bulkNotification, teamReportNotification, copyIntoClientEmails,
        enableWebProfile, webProfileWorkOnline
      };

      this.setState({
        originalProfile: newProfile,
        hasChanges: false,
        disableUpdateButton: true,
        openBackdrop: false
      });

    } else {
      if (update.data.emojis)
        this.openAlertModal("Failed", "The update failed. Please remove all emojis - the system does not currently allow for saving emojis.");
      else
        this.openAlertModal("Failed", "The update failed unexpectedly.");
    }

  } else if (!doesCurrentPasswordMatch) {
    this.openAlertModal("Failed", "Update failed - your current password is incorrect");
  } else if (!doesNewPasswordsMatch) {
    this.openAlertModal("Failed", "Update failed - the confirmed password doesn't match the new password");
  } else {
    this.openAlertModal("Failed", "Update failed - password must be strong, please see guidelines above");
  }
};

  openAlertModal = (title, message, callback) => {
    this.setState({
      alertModalTitle: title,
      alertMessage: message,
      openAlertModal: true,
      closeModalCallback: callback??this.closeModal
    })
  }

handlePassword = (e) => {
  HandlePasswordEditChange(e, this, this.state.password, this.state.confirmPassword, true);
  setTimeout(() => {
    if (!this.state.password) {
      this.setState({ currentPassword: "" }, () => {
        const input = document.getElementById("currentPassword");
        if (input) input.value = "";
        this.checkForChanges();
      });
    } else {
      this.checkForChanges();
    }
  }, 0);
};



  showPassword = () => {
    var x = document.getElementById("password");
    var y = document.getElementById("confirmPassword");
    var z = document.getElementById("currentPassword");
    if (z.type === "password") {
      x.type = "text";
      y.type = "text";
      z.type = "text"
    } else {
      x.type = "password";
      y.type = "password";
      z.type = "password";
    }
  }

validateImageFile = (e) => {
  const fileInput = e.target;

  if (!fileInput.files || fileInput.files.length === 0) {
    this.setState({ profileImage: null }, this.checkForChanges);
    return;
  }

  const file = fileInput.files[0];
  const fileSize = file.size;
  const fileMb = fileSize / 1024 / 1024;

  if (fileMb > 8) {
    this.openAlertModal("Failed", "Please ensure that your profile photo is less than 8MB.");
    fileInput.value = "";
    this.setState({ profileImage: null }, this.checkForChanges);
    return;
  }

  const idxDot = file.name.lastIndexOf(".") + 1;
  const extension = file.name.substr(idxDot).toLowerCase();

  if (!(extension === "jpg" || extension === "jpeg" || extension === "png")) {
    this.openAlertModal("Failed", "Only jpg/jpeg and png files are allowed!");
    fileInput.value = "";
    this.setState({ profileImage: null }, this.checkForChanges);
    return;
  }

  const output = document.getElementById('profile-pic');
  output.src = URL.createObjectURL(file);
  output.onload = function() {
    URL.revokeObjectURL(output.src);
  };

  this.setState({ profileImage: file }, this.checkForChanges);
};

   characterCount = (maxChars, event)=>{
    let totalChars= event.target.value.length;
    let displayChars=document.getElementById(event.target.id+"ID");
   
    if(totalChars>0){
      displayChars.innerHTML=totalChars +" / " + maxChars;
    }else{
      displayChars.innerHTML= "";
    }
  }

  addAssistant = async () => {
    
    if (!this.state.assistantName || !this.state.assistantSurname || !this.state.assistantEmail) {
      this.setState({
        modalIsOpen: false,
        message: "Please fill in all fields: name, surname, and email.",
        level: "danger"
      })
      this.showToast()
      return;
    }

    if (!utils.validateEmail(this.state.assistantEmail)) {
      this.setState({
        modalIsOpen: false,
        message: "Please enter a valid email address.",
        level: "danger"
      })
      this.showToast();
      return;
    }

    this.setState({addAssistantModal:false})
    let addResult = await aserver.post(`api/v2/coaches/${this.state.id}/newAssistantRequested`, {
      name: this.state.assistantName,
      surname: this.state.assistantSurname,
      email: this.state.assistantEmail,
    });
    if (addResult.data.success) {
      this.openAlertModal("Success", addResult.data.message, (e) => this.refreshAssistants(e))
    } else {
      this.openAlertModal("Failed", `Requesting assistant failed: ${addResult.data.error}`)
    }
  }

  scrollToSection = (id)=>{
    const section = document.getElementById(id);
    section.scrollIntoView( { behavior: 'smooth', block: 'start' } );
  }

  openEdit =(uuid, name, surname, email)=>{
    this.setState({
      openEditModal:true,
      assistantUUID:uuid,
      assistantName: name,
      assistantSurname:surname,
      assistantEmail:email
    })
  }

  updateAssistant = async () => {
    let editResult = await aserver.post(`api/v2/coaches/${this.state.id}/assistantEdit/${this.state.assistantUUID}`, {
      name: this.state.assistantName,
      surname: this.state.assistantSurname,
      email: this.state.assistantEmail
    });
  
    if (editResult.data.success) {
      this.setState(prevState => {
        const updatedAssistants = prevState.listOfAssistants.map(assistant => {
          if (assistant.uuid === this.state.assistantUUID) {
            return {
              ...assistant,
              name: this.state.assistantName,
              surname: this.state.assistantSurname,
              email: this.state.assistantEmail
            };
          }
          return assistant;
        });
  
        return {
          listOfAssistants: updatedAssistants,
          assistantName: "",
          assistantSurname: "",
          assistantEmail: "",
          openEditModal: false,
          message: "Success",
          level: "success"
        };
      });
  
      this.showToast();
    } else {
      this.setState({
        openEditModal: false,
        message: "Failed",
        level: "danger"
      });
      this.showToast();
    }
  }
  openDeleteConfirm = (uuid, name, surname) => {
    this.setState({
      deleteConfirmModal: true,
      deleteAssistantUUID: uuid,
      deleteAssistantDisplayName: `${name} ${surname}`
    });
  }

  deleteAssistant = async () => {
    const uuid = this.state.deleteAssistantUUID;
    let result = await aserver.del(`api/v2/coaches/${this.state.id}/assistants/${uuid}`);
    if (result.data.success) {
      this.setState(prevState => ({
        listOfAssistants: prevState.listOfAssistants.filter(a => a.uuid !== uuid),
        deleteConfirmModal: false,
        deleteAssistantUUID: "",
        deleteAssistantDisplayName: ""
      }));
    } else {
      this.setState({deleteConfirmModal: false});
      this.openAlertModal("Failed", "Could not delete assistant.");
    }
  }

  downloadImage = async (src, filename) => {
      const response = await fetch(src);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      const extension = src.split('.').pop().split(/[?#]/)[0] || 'jpg';
      link.download = `${filename}.${extension}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
  };

  toggle2FA = async(isEnabled) => {
    let toggle = await aserver.post(`api/v2/coaches/setTwoFactor/${this.state.id}`,{
      twoFactorEnabled:isEnabled
    })
    this.setState({ 
      twoFactorEnabled: isEnabled,
      qrcode: toggle.data.qrcode,
      secret: toggle.data.secret,
      showTwoFactorSection:isEnabled,
      authentication:"",
      hideSwitch:isEnabled
     });
  };

  sendAuthenticatorCode = async()=>{
    let sendCode = await aserver.post(`api/v2/coaches/verifyTwoFactor/${this.state.id}`,{
      token: this.state.authentication
    })
    if(sendCode.data.success){
      
      this.setState({
        showTwoFactorSection:false,
        hideSwitch:false
      })
      this.scrollToSection("twoFactorSection")
      this.success()
    }else{
      this.openAlertModal("Failed", "Code not correct - please try again")
    }
  }

  copyToClipboard = () => {
    navigator.clipboard.writeText(this.state.secret)
    this.toastMessage("Copied to clipboard", "success")
  };

  copyLink = async(link)=>{
    await navigator.clipboard.writeText(link)
    this.toastMessage("Copied to clipboard", "success")
  }

  accreditationLink = (level) => {
    return window.location.origin + `/coaches/accreditation/${this.state.registerUUID}/${level}`;
  }

  buildAccreditationEmbedHtml = (level, publicImagePath, title) => {
    const imageUrl = window.location.origin + publicImagePath;
    const affirmationUrl = this.accreditationLink(level);
    return `<a href="${affirmationUrl}" target="_blank" rel="noopener noreferrer"><img src="${imageUrl}" alt="${title}" style="width:200px;height:auto;border:0;" /></a>`;
  }


  toastMessage = (text, level) => {
    this.setState({
      message: text,
      level: level,
    })
    this.showToast()
  }

  escFunction = (event) => {
    if (event.keyCode === 27) {
      this.closeModal()
    }
  }

  refreshAssistants = (event) => {
    const { id } = this.state;
    this.listAssistants(id);
    this.closeModal();  
  }

  componentDidMount() {
    document.addEventListener("keydown", this.escFunction, false);
    this.fetchCoach();
    this.fetchCoachQuestionnaireStatus();
    this.fetchAccreditations();
    this.fetchCustomSections();
  }

  // Coach-specific sections are served only to the coach they belong to, so their content
  // never ships in this bundle (see routes/coach_sections.js).
  fetchCustomSections = async () => {
    try {
      let response = await aserver.get(`api/v2/coaches/${this.state.id}/customSections`);
      this.setState({ customSections: response.data.sections || [] });
    } catch (err) {
      console.log(err);
    }
  }

  // Title/description/stamp image per level - the Accreditations table is the single source for
  // this, shared with the public affirmation page (routes/coaches.js's getAccreditationAffirmation).
  fetchAccreditations = async () => {
    try {
      let response = await aserver.get('api/v2/accreditations');
      this.setState({ accreditations: response.data || [] });
    } catch (err) {
      console.log(err);
    }
  }

  fetchCoachQuestionnaireStatus = async () => {
    try {
      let response = await aserver.get(`api/v2/coaches/${this.state.id}/coachQuestionnaire`);
      let questionnaire = response.data.questionnaire;
      this.setState({ coachQuestionnaireCompleted: !!(questionnaire && questionnaire.completedAt) });
    } catch (err) {
      console.log(err);
    }
  }

  render() {
    const classes = this.props.classes;
    const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
    const {loggedInAssistantEmail, isBeingAssisted} = this.state;
    const disableText = {
      color: !this.state.enableWebProfile ? "#8080804d" : "#3f51b5"
    }

    const disableLable = {
      color: !this.state.enableWebProfile ? "#8080804d" : "black"  
    }

    const hideCurrentPassword = {
      display:this.state.showCurrentPassword?"block":"none"
    }

   
    const LevelDisplay = ({ accreditations, accreditedLevels, isL1Conversionista }) => {
      // Levels are independent tracks - a stamp shows for each one the coach is fully accredited for.
      // Title/description/stamp image all come from the Accreditations table (fetched once into
      // this.state.accreditations) - no locally duplicated copy of that data here.
      let levelsToDisplay = accreditations.filter(a => accreditedLevels[a.level]);
      if (isL1Conversionista)
          levelsToDisplay = levelsToDisplay.filter(a=>a.level!==1);
      return (
        <div>
        {levelsToDisplay.length===0 ? (
          <p>Your accreditation stamps will appear here when you are accredited. An accreditation stamp is not provided for Level 1 conversions.</p>
        ) : (
          levelsToDisplay.map(({ level, title, stampImagePath }) => {
            const affirmationUrl = this.accreditationLink(level);
            return (
              <div key={level} style={{ marginBottom: '14px' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <img
                    src={stampImagePath}
                    style={{ width: "100px", height: "50px", cursor: 'pointer' }}
                    onClick={() => this.downloadImage(stampImagePath, title)}
                  />
                  <span
                    style={{ cursor: 'pointer', marginLeft: '10px' }}
                    onClick={() => this.downloadImage(stampImagePath, title)}
                  >
                    {title}
                  </span>
                  <img
                    src={downloadIcon}
                    style={{ width: "20px", height: "20px", marginLeft: '10px', cursor: 'pointer' }}
                    onClick={() => this.downloadImage(stampImagePath, title)}
                  />
                  <a
                    href="#"
                    onClick={(e) => { e.preventDefault(); this.copyLink(this.buildAccreditationEmbedHtml(level, stampImagePath, title)); }}
                    className="copy-link-btn"
                    style={{ marginLeft: '10px' }}
                  >
                    <img src={blueCopyIcon}></img>
                    Copy embed code
                  </a>
                </div>
                <div style={{ marginLeft: '110px', marginTop: '2px', fontSize: '0.85em' }}>
                  Clickthrough link: <a href={affirmationUrl} target="_blank" rel="noreferrer">{affirmationUrl}</a>
                </div>
              </div>
            );
          })
          )}
        </div>
      );
    };

    let assessmentLink = window.location.origin + `/coachportal/register/${this.state.registerUUID}`
    let pairAssessmentLink = window.location.origin + `/coachportal/pairregister/${this.state.registerUUID}`


    return (
      <>
        <div className={classes.root}>
          <CssBaseline />
          <main className={classes.content}>
            <div className={classes.appBarSpacer} />
            <Container maxWidth="lg" className={classes.container}>
              <Grid container>
                <Grid item xs={12} md={12} lg={12}>
                  <div  className="sticky" style={{"textAlign":"center"}}>
                    <Button id="detailButton" style={{display:this.state.isBeingAssisted?"none":""}} className='tabButton' onClick={(e)=>this.scrollToSection("sectionDetails","detailButton" )}>Details</Button>
                    <Button id="passwordButton" className='tabButton' onClick={(e)=>this.scrollToSection("sectionPassword","passwordButton" )}>Password</Button>
                    <Button id="2FAButton" className='tabButton' onClick={(e)=>this.scrollToSection("section2FA","2FAButton" )}>Two-Factor Authentication</Button>
                    <Button id="assistantButton" style={{display:this.state.isBeingAssisted?"none":""}} className='tabButton' onClick={(e)=>this.scrollToSection("assistantsSection", "assistantButton" )}>Assistants</Button>
                    <Button id="policySection" className='tabButton' onClick={(e)=>this.scrollToSection("policy", "policyButton" )}>Policies</Button>
                    <Button id="coachQuestionsButton" style={{display:this.state.isBeingAssisted?"none":""}} className='tabButton' onClick={(e)=>this.scrollToSection("coachQuestions", "coachQuestionsButton" )}>Get to Know You</Button>
                    <span style={{display: this.state.onlyMiniAssessment ?"none": "inline"}}>
                    <Button id="notificationButton" style={{display:this.state.isBeingAssisted?"none":""}} className='tabButton' onClick={(e)=>this.scrollToSection("sectionNotifications", "notificationButton" )}>Notifications</Button>
                    <Button id="resourceButton" className='tabButton' onClick={(e)=>this.scrollToSection("webResourcesSection", "resourceButton" )}>Web Resources</Button>
                    <Button id="webProfileButton" style={{display:this.state.isBeingAssisted?"none":""}} className='tabButton' onClick={(e)=>this.scrollToSection("sectionWebProfile", "webProfileButton")}>Web Profile</Button>
                    </span>
                  </div>
                  <Paper className={fixedHeightPaper}>
                    <div className="top">
                      <div style={{display:isBeingAssisted?"none":"block"}}>
                        <div id='sectionDetails'></div>
                        <h3 id='detailSection' className='headings'>Details</h3>
                        <h4 htmlFor="user" style={{ marginBottom: "0" }} >Name</h4>
                        <div className="input-wrapper">
                          <input className="coach-input" type="text" name="name" id="username" onChange={this.handleChange} value={this.state.name} placeholder='enter here'  required />
                        </div>
                        <p></p>
                        <h4 htmlFor="user" style={{ marginBottom: "0" }} >Surname</h4>
                        <div className="input-wrapper">
                          <input className="coach-input" type="text" name="surname" id="usersurname" onChange={this.handleChange} value={this.state.surname} placeholder='enter here'  required />
                        </div>
                        <p></p>
                        <h4 htmlFor="user" style={{ marginBottom: "0" }} >Business Name</h4>
                        <div className="input-wrapper">
                          <input className="coach-input" type="text" name="businessName" id="userbusiness" onChange={this.handleChange} value={this.state.businessName} placeholder='enter here'  required />
                        </div>
                        <p></p>
                        <h4 htmlFor="user" style={{ marginBottom: "0" }} >Email</h4>
                        <div className="input-wrapper">
                          <input className="coach-input" type="email" name="email" id="useremail" onChange={this.handleChange} value={this.state.email} placeholder='enter here'  required />
                        </div>
                        <p></p>
                        <h4 htmlFor="user" style={{ marginBottom: "0" }} >Phone Number</h4>
                        <div className="input-wrapper">
                          <input className="coach-input" type="number" name="phone" id="userphone" onChange={this.handleChange} value={this.state.phone} placeholder='enter here'  required />
                        </div>
                        <p></p>
                        {/*===========================Billing Info============================== */}
                        <div>
                          <h2>Billing Info</h2>
                          <h4 htmlFor="user" style={{ marginBottom: "0" }} >Postal Address</h4>
                          <div className="input-wrapper">
                            <input className="coach-input" type="text" name="postalAddress" id="useraddress" onChange={this.handleChange} value={this.state.postalAddress} placeholder='enter here'  />
                          </div>
                          <p></p>
                          <h4 htmlFor="user" style={{ marginBottom: "0" }} >Vat No.</h4>
                          <div className="input-wrapper">
                            <input className="coach-input" type="number" name="vatNumber" id="usernumber" onChange={this.handleChange} value={this.state.vatNumber} placeholder='enter here' />
                          </div>
                          <p></p>
                          <h4 htmlFor="user" style={{ marginBottom: "0" }} >Company Reg. Number</h4>
                          <div className="input-wrapper">
                            <input className="coach-input" type="text" name="companyRegNumber" id="userreg" onChange={this.handleChange} value={this.state.companyRegNumber} placeholder='enter here'  />
                          </div>
                        </div>
                        <p></p>
                      </div>
                      {/* ====================== Password section ======================*/}
                      <div id='sectionPassword'></div>
                      <h3 id='passwordSection' className='headings'>Password {isBeingAssisted?`(for ${loggedInAssistantEmail})`:"" }</h3>
                        <h4 htmlFor="user" style={{ marginBottom: "0" }} >New Password</h4>
                        <div className="input-wrapper">
                          <input className="coach-input" autoComplete="new-password" type="password" name="password" id="password" minLength="8" onChange={(e) => this.handlePassword(e)} value={this.state.password} placeholder='enter here'  />
                        </div>
                        <p></p>
                        <h4 htmlFor="user" style={{ marginBottom: "0" }} >Confirm Password</h4>
                        <div className="input-wrapper">
                          <input className="coach-input" autoComplete="new-password" type="password" name="confirmPassword" id="confirmPassword" minLength="8" onChange={(e) => this.handlePassword(e)} value={this.state.confirmPassword} placeholder='enter here'  />
                        </div>
                        <p></p>
                        <h4 htmlFor="user" style={{ marginBottom: "0", display: this.state.password || this.state.confirmPassword ? "block" : "none"  }} >Current Password</h4>
                        <div className="input-wrapper" style={hideCurrentPassword}>
                          <input className="coach-input" autoComplete="new-password"  type="password" name="currentPassword" id="currentPassword" minLength="8" onChange={this.handleChange} value={this.state.currentPassword} placeholder='enter here'  />
                        </div>
                        <div style={{ textAlign: "left" }}>
                          <input type="checkbox" onChange={this.showPassword} name="showPassword" id="showPassword" value="1" placeholder='enter here' />
                          <label className="sendReportLabel" htmlFor="showPassword">Show Password</label>
                        </div>
                      <p></p>
                      <PasswordDiv component={this} />
                      <p></p>

                      {/* ===========================2FA======================= */}
                      <div id='section2FA'></div>
                      <h3 id='twoFactorSection' className='headings'>Two-Factor Authentication</h3>
                      <div style={{ textAlign: "left" }}>
                        <div className='tile'>
                          <div style={{display:this.state.hideSwitch?"none":"block"}}>
                            Disabled 
                            <Switch
                              checked={this.state.twoFactorEnabled }
                              onChange={(event) => this.toggle2FA(event.target.checked)}
                            />
                            Enabled
                          </div>
                          <div style={{display:this.state.showTwoFactorSection?"block":"none"}}>
                            <h4>1) Scan the QR code (or enter the setup key) in your Authenticator app</h4>
                            <p>QR Code:</p>
                            <img src={this.state.qrcode} alt="QR Code"/>
                            <p onClick={this.copyToClipboard}>
                              Secret code/ Setup key:<br></br> <span style={{ cursor: "pointer" }}>{this.state.secret}</span>
                              <img src={blueCopyIcon}
                                alt="Copy to clipboard"
                                style={{ cursor: "pointer","width": "30px",
                                  "marginBottom": "-10px" }}
                                />
                            </p>
                            <h4>2) Enter the code displayed in your Authenticator app</h4>
                            <h4 style={{marginBottom:0}}>Authentication code</h4>
                            <div className="input-wrapper">
                              <input className="coach-input" type="text" name="authentication" id="authentication" onChange={this.handleChange} placeholder='enter here'  value={this.state.authentication} onKeyDown={(event) => {
                                if (event.key === 'Enter') {
                                  this.sendAuthenticatorCode();
                                }
                              }} />
                            </div>
                            <br></br>
                            <h4>3) Click Verify</h4>
                            <Button variant="contained" color="primary" onClick={()=>this.sendAuthenticatorCode()}> Verify</Button>
                          </div>
                        </div>
                      </div>

                      {/* =====================Add Assistant ====================*/}
                      <div style={{display:this.state.isBeingAssisted?"none":"block"}}>
                        <div id='assistantsSection'></div>
                        <h3 id='assistantSection' className='headings'>Assistants</h3>
                        <div style={{ textAlign: "left" }}>
                            {this.state.listOfAssistants.map((info, index) => {
                              const assistantNumber = index + 1;
                              return (
                                <div key={info.email} className='tile'>
                                  <div style={{color:info.isBlocked?"rgb(153 153 153 / 65%)":"#000"}}>
                                    <b>Assistant {assistantNumber}</b>
                                    <br/>
                                    Name: <b>{info.name} {info.surname}</b> <EditIcon style={{"cursor": "pointer"}} onClick={()=>this.openEdit(info.uuid, info.name, info.surname, info.email)} /><DeleteForeverIcon style={{"cursor": "pointer"}} onClick={()=>this.openDeleteConfirm(info.uuid, info.name, info.surname)} />
                                    <br/>
                                    Email: <b>{info.email}</b>   
                                  </div>
                                  <div>
                                    Unblocked 
                                    <Switch
                                      checked={info.isBlocked}
                                      onChange={() => this.handleToggleBlock(info.uuid, info.isBlocked ? 'unblock' : 'block')}
                                    />
                                    Blocked
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                        <Button variant="contained" color="primary" onClick={()=>this.setState({addAssistantModal:true})}> Add Assistant</Button>
                      </div>
                      {/*======================Policies======================== */}
                      <div id='policySection'></div>
                      <h3 id='policy' className='headings'>Policies</h3>                        
                      <PolicyList
                        coachUUID={this.state.id}
                      />
                      <div>The End-user License Agreement can be found <a href="https://aephoriagroup.com/eula/" target="_blank">here</a></div>
                      <div>General Terms can be found <a href="https://aephoriagroup.com/general-terms/" target="_blank">here</a></div>

                      {/*======================Get to Know You (coach questions) - not shown to assistants======================== */}
                      <div style={{display:isBeingAssisted?"none":"block"}}>
                        <div id='coachQuestions'></div>
                        <h3 id='coachQuestionsHeading' className='headings'>Get to Know You</h3>
                        <div style={{ textAlign: "left" }}>
                          <p>A few quick questions to help us understand you and your practice, and improve your experience on the portal. Answer them whenever suits you - you can update your answers at any time.</p>
                          <Button variant="contained" color="primary" onClick={()=>this.setState({openCoachQuestionsModal:true})}>{this.state.coachQuestionnaireCompleted ? "Update Your Answers" : "Answer the questions"}</Button>
                        </div>
                      </div>

                      <div style={{display:this.state.onlyMiniAssessment ?"none":"block"}}>
                        {/*======================Notification Preferences======================== */}
                        <div id='sectionNotifications'></div>
                        <div style={{display:isBeingAssisted?"none":"block"}}>
                          <h3 id='notificationSection' className='headings'>Notification Preferences</h3>
                          <div style={{ textAlign: "left" }}>
                            <div>
                              <input type="checkbox" onChange={e => this.checkPreferences(e)} checked={this.state.singleNotification === 1} name="singleNotification" id="singleNotification" value="1" placeholder='enter here'  />
                              <label className="sendReportLabel" htmlFor="singleNotification">For assessments I added individually, send me email when they are completed or marked</label>
                            </div>
                            <br></br>
                            <div>
                              <input type="checkbox" onChange={e => this.checkPreferences(e)} checked={this.state.bulkNotification === 1} name="bulkNotification" id="bulkNotification" value="1" placeholder='enter here'  />
                              <label className="sendReportLabel" htmlFor="bulkNotification">For assessments I added in bulk, send me email when they are completed or marked</label>
                            </div>
                            <br></br>
                            <div>
                              <input type="checkbox" onChange={e => this.checkPreferences(e)} checked={this.state.teamReportNotification === 1} name="teamReportNotification" id="teamReportNotification" value="1" placeholder='enter here'  />
                              <label className="sendReportLabel" htmlFor="teamReportNotification">Send me email when a team report I requested is ready for downloading</label>
                            </div>
                            <br></br>
                            <div>
                              <input type="checkbox" onChange={e => this.checkPreferences(e)} checked={this.state.copyIntoClientEmails === 1} name="copyIntoClientEmails" id="copyIntoClientEmails" value="1" placeholder='enter here'  />
                              <label className="sendReportLabel" htmlFor="copyIntoClientEmails">Copy me and my assistants into all emails sent to the client (invites, reminders, individual and pair reports)</label>
                            </div>
                            <br></br>
                          </div>
                          <h4 style={{ textAlign: "left", marginBottom: "0" }}>Extra Notification Recipients</h4>
                          <h5 style={{ textAlign: "left", marginTop: "0" }}>*One email address per line</h5>
                          <div style={{ textAlign: "left" }}>
                            <textarea
                              rows="5"
                              cols="50"
                              id="extraEmails"
                              name="extraEmails"
                              style={{ width: "100%" }}
                              value={this.state.extraEmails || ""}
                              onChange={(e) => {
                                this.setState({ extraEmails: e.target.value }, this.checkForChanges);
                              }}
                            />
                          </div>

                        {/* ===============Web Resource Section ================*/}

                        <div id='webResources'></div>
                        <h3 id='webResourcesSection' className='headings'>Web Resources</h3>                        
                        <h2>Stamps</h2>
                        <div style={{maxWidth:'40em', marginBottom: '1em'}}>
                          Each stamp below shows an accreditation you've completed with Aephoria. You can download the stamp image to use as-is, or copy the embed code to place directly on your own website - it will show the stamp image, and if a visitor clicks on it, they'll be taken to an Aephoria page confirming that you are accredited for that stamp. Below each stamp is the clickthrough link itself, so you can preview exactly what your visitors will see before you publish it.
                        </div>
                        <LevelDisplay
                          accreditations={this.state.accreditations}
                          accreditedLevels={{
                            1: this.state.isAccreditedLevel1,
                            2: this.state.isAccreditedLevel2,
                            3: this.state.isAccreditedLevel3,
                            4: this.state.isAccreditedLevel4,
                            5: this.state.isAccreditedLevel5,
                            6: this.state.isAccreditedLevel6,
                          }}
                          isL1Conversionista={this.state.isL1Conversionista}
                        />
                        <h2 id='selfRegisterSection'>Client Self-Registration</h2>

                        {/* <h4>Assessment self-registration</h4> */}
                        <div style={{maxWidth:'40em'}}>
                          The Self-Register links below can be used on your website or given to clients where you prefer them to pay Aephoria directly for assessments, instead of you being billed for credits. A client will follow these links to pay for Enneagram assessments and Pair Reports. Aephoria will then email them an invite (with text from your "Self-register Invite" email template). The client can then register for, and complete the assessment.
                          <br></br><br></br>
                          The client will show up in your coach portal under the Assessments tab once they have completed the questionnaire. Also, on completion, Aephoria will automatically email the client a link to download their Enneagram Report (the text for this email will be taken from your "Self Register Send Report" or "Pair Self-Register Send Report" email templates.
                          <br></br><br></br>
                          Self-registration is available for the Enneagram assessment at present and costs the client $55 or R550 + VAT or for the Pair reports (Couples or Colleagues). If the clients both have Enneagram results already, the pair reports cost $110 or R1100 + VAT. 
                        </div>
                        <h4>Enneagram assessment self-registration</h4>
                        <p><a href={assessmentLink} target="_blank" rel="noreferrer">{assessmentLink}</a></p>
                        <a href="#" onClick={()=>this.copyLink(assessmentLink)} className="copy-link-btn">
                          <img src={blueCopyIcon}></img>
                          Copy link
                        </a>
                        <h4>Pair report self-registration</h4>
                        <p><a href={pairAssessmentLink} target="_blank" rel="noreferrer">{pairAssessmentLink}</a></p>
                        <a href="#" onClick={()=>this.copyLink(pairAssessmentLink)} className="copy-link-btn">
                          <img src={blueCopyIcon}></img>
                          Copy link
                        </a>

                        {/* ===============Coach-specific sections (served per coach, see fetchCustomSections) ================*/}
                        {(this.state.customSections || []).map((section, s) => (
                          <div key={s}>
                            <h2>{section.heading}</h2>
                            {section.items.map((item, i) => (
                              <div key={i}>
                                <h3>{item.title}</h3>
                                <h4>Self-register link</h4>
                                <p><a href={item.link} target="_blank" rel="noreferrer">{item.link}</a></p>
                                <a href="#" onClick={()=>this.copyLink(item.link)} className="copy-link-btn">
                                  <img src={blueCopyIcon}></img>
                                  Copy link
                                </a>
                                <h4>QR Code</h4>
                                <img src={item.qrCode} alt={`QR code for ${item.title}`} style={{width: '10em', height: '10em', display: 'block'}} />
                                <a href={item.qrCode} download={item.qrFilename} className="copy-link-btn">
                                  <img src={downloadIcon}></img>
                                  Download svg
                                </a>
                              </div>
                            ))}
                          </div>
                        ))}

                        {/* =========================== Web Practitioner Profile ===========================*/}
                        <div id='sectionWebProfile'></div>
                        <div>
                          <h3 id='webProfileSection' className='headings'>Web Practitioner Profile</h3>
                          <div style={{ textAlign: "left" }}>
                            <input type="checkbox" onChange={e => this.checkIfDisabled(e)} checked={this.state.enableWebProfile} name="webProfileSync" id="webProfileSync" value="true" placeholder='enter here'  />
                            <label className="sendReportLabel" htmlFor="enableWebProfile">Yes, add me to the <a href="https://aephoriagroup.com/practitioners" target="_blank" rel="noopener noreferrer">Practitioners</a> section on the Aephoria website.<br></br>I will then keep the fields below updated, knowing Aephoria will update my profile in the Practitioners section.</label>
                            <br></br>
                            <br></br>
                          </div>
                          <form id="webProfileForm" name="webProfileForm">
                            <p></p>
                            <h4 htmlFor="user" style={{ marginBottom: "0" }} className={!this.state.enableWebProfile ? "disable-label" : ""}>Profile Picture</h4>
                            <div className="input-wrapper">
                              <img className="profile-pic" id="profile-pic" alt="Coach" src={`${aserver.serverroot()}/api/v2/coaches/${this.state.id}/profilePhoto`} />
                              <input className="coach-input" id="profileImage" name="profileImage" type="file" onChange={(e)=>this.validateImageFile(e)} style={disableText} accept="image/png, image/jpg, image/jpeg" maxLength="50" disabled={!this.state.enableWebProfile} placeholder='enter here'  />
                            </div>
                            <p></p>
                            <h4 htmlFor="user" style={{ marginBottom: "0" }} className={!this.state.enableWebProfile ? "disable-label" : ""}>Email</h4>
                            <div className="input-wrapper">
                              <input className="coach-input" type="email" name="webProfileEmail" id="webProfileEmail" style={disableText} maxLength="254" disabled={!this.state.enableWebProfile} onChange={this.handleChange} value={this.state.webProfileEmail} placeholder='enter here'  required />
                            </div>
                            <p></p>
                            <h4 htmlFor="user" style={{ marginBottom: "0" }} className={!this.state.enableWebProfile ? "disable-label" : ""}>Phone Number (WITH COUNTRY DIALLING CODE)</h4>
                            <div className="input-wrapper">
                              <span className="static-plus">+</span>
                              <input className="coach-input" type="text" name="webProfilePhoneNumber" maxLength="54" id="webProfilePhoneNumber" style={disableText} disabled={!this.state.enableWebProfile} onChange={this.handleChange} value={this.state.webProfilePhoneNumber} required />
                            </div>
                            <p></p>
                            <h4 htmlFor="user" style={{ marginBottom: "0" }} className={!this.state.enableWebProfile ? "disable-label" : ""}>Website:</h4>
                            <div className="input-wrapper">
                              <input className="coach-input" type="text" name="webProfileWebSite" id="webProfileWebSite" style={disableText} maxLength="254" disabled={!this.state.enableWebProfile} onChange={this.handleChange} value={this.state.webProfileWebSite} placeholder='enter here'  required />
                            </div>
                            <p></p>
                            <h4 htmlFor="user" style={{ marginBottom: "0" }} className={!this.state.enableWebProfile ? "disable-label" : ""}>City</h4>
                            <div className="input-wrapper">
                              <input className="coach-input" type="text" name="webProfileCity" id="webProfileCity" style={disableText} maxLength="254" disabled={!this.state.enableWebProfile} onChange={this.handleChange} value={this.state.webProfileCity} placeholder='enter here'  required />
                            </div>
                            <p></p>
                            <h4 htmlFor="user" style={{ marginBottom: "0" }} className={!this.state.enableWebProfile ? "disable-label" : ""}>Country</h4>
                            <div className="input-wrapper">
                              <input className="coach-input" type="text" name="webProfileCountry" id="webProfileCountry" style={disableText} maxLength="254" disabled={!this.state.enableWebProfile} onChange={this.handleChange} value={this.state.webProfileCountry} placeholder='enter here'  required />
                            </div>
                            <p></p>
                            <h4 htmlFor="user" style={{ marginBottom: "0" }} className={!this.state.enableWebProfile ? "disable-label" : ""}>Language</h4>
                            <div className="input-wrapper">
                              <input className="coach-input" type="text" name="webProfileLanguages" id="webProfileLanguages" style={disableText} maxLength="254" disabled={!this.state.enableWebProfile} onChange={this.handleChange} value={this.state.webProfileLanguages} placeholder='enter here'  required />
                            </div>
                            <p></p>
                            <h4 htmlFor="user" style={{ marginBottom: "0" }} className={!this.state.enableWebProfile ? "disable-label" : ""}>Scope of practice</h4>
                            <div style={{ textAlign: "left" }}>
                              <textarea rows="5" cols="80" className="text-area" name="webProfileScopeOfPractice" id="webProfileScopeOfPractice" style={disableText} maxLength="1000" disabled={!this.state.enableWebProfile} placeholder="e.g. Coaching, Therapy, Organization Development, Human Resources"
                              onKeyUp={(event)=>this.characterCount(1000, event)}
                              onChange={(e) => {
                                this.setState({ webProfileScopeOfPractice: e.target.value }, this.checkForChanges);
                              }}
                              />
                              <label htmlFor="user" style={disableLable}>Scope Of Practice</label>
                            </div>
                            <div id='count'><span id="webProfileScopeOfPracticeID"> </span></div>
                            <p></p>
                            <h4 htmlFor="user" style={{ marginBottom: "0" }} className={!this.state.enableWebProfile ? "disable-label" : ""}>Specialization</h4>
                            <div style={{ textAlign: "left" }}>
                              <textarea rows="5" cols="80" className="text-area" name="webProfileSpecialization" id="webProfileSpecialization" maxLength="1000" style={disableText} disabled={!this.state.enableWebProfile} 
                              onKeyUp={(event)=>this.characterCount(1000, event)}
                              onChange={(e) => {
                                this.setState({ webProfileSpecialization: e.target.value }, this.checkForChanges);
                              }}
                              />
                              <label htmlFor="user" style={disableLable}>specialization/core focus</label>
                            </div>
                            <div id='count'><span id="webProfileSpecializationID"> </span></div>
                            <p></p>
                            <p></p>
                            <div style={{ textAlign: "left" }}>
                              <input type="checkbox" onChange={(e)=>this.checkOnlinePreferences(e)} checked={this.state.webProfileWorkOnline}  id="webProfileWorkOnline" value={this.state.webProfileWorkOnline} disabled={!this.state.enableWebProfile} placeholder='enter here' />
                              <label className="sendReportLabel" style={disableLable} htmlFor="enableWebProfile" >Work online?</label>
                            </div>
                          </form>
                        </div>
                        </div>

                      </div>
                      {this.state.hasChanges && (
                        <Button className='floatingSubmitButton' variant="contained" onClick={this.handleSubmit} disabled={this.state.disableUpdateButton} type="submit">Save Changes</Button>
                      )}
                      <Modal isOpen={this.state.openCoachQuestionsModal} onClose={()=>this.setState({openCoachQuestionsModal:false})}>
                        <h1 style={{margin:"0"}}>Get to Know You</h1>
                        <div className="edit-div">
                          <CoachQuestions coachUUID={this.state.id} allowSkip={false} onDone={(complete)=>this.setState({openCoachQuestionsModal:false, coachQuestionnaireCompleted: this.state.coachQuestionnaireCompleted || !!complete})} />
                        </div>
                      </Modal>
                      <Modal isOpen={this.state.deleteConfirmModal} onClose={()=>this.setState({deleteConfirmModal:false})}>
                        <h3 style={{margin:"0"}}>Delete Assistant</h3>
                        <div className="edit-div">
                          <p>Are you sure you want to delete <b>{this.state.deleteAssistantDisplayName}</b> as an assistant? This cannot be undone.</p>
                          <div style={{ textAlign: "left" }}>
                            <Button variant="contained" color="secondary" onClick={this.deleteAssistant}>Delete</Button>
                            <Button variant="contained" color="primary" onClick={()=>this.setState({deleteConfirmModal:false})}>Cancel</Button>
                          </div>
                        </div>
                      </Modal>
                      <Modal isOpen={this.state.openEditModal || this.state.addAssistantModal} onClose={this.closeModal}>
                        <h3 style={{margin:"0"}}>{this.state.openEditModal ? "Edit Assistant" : "Add Assistant"}</h3>
                        <div className="edit-div">
                          {this.state.addAssistantModal && (
                            <>
                              <p>Please provide the details of your new assistant.</p>
                            </>
                          )}
                          <div className="input-wrapper-2">
                            <input
                              className="input"
                              type="text"
                              name="assistantName"
                              id="assistantName"
                              maxLength="45"
                              onChange={this.handleChange}
                              value={this.state.assistantName}
                              style={{ margin: "10px 0px", padding: "8px 16px" }}
                              placeholder='enter here' 
                            />
                            <label className="edit">Name</label>
                          </div>
                          <div className="input-wrapper-2">
                            <input
                              className="input"
                              type="text"
                              name="assistantSurname"
                              id="assistantSurname"
                              maxLength="45"
                              onChange={this.handleChange}
                              value={this.state.assistantSurname}
                              style={{ margin: "10px 0px", padding: "8px 16px" }}
                              placeholder='enter here' 
                            />
                            <label className="edit">Surname</label>
                          </div>
                          <div className="input-wrapper-2">
                            <input
                              className="input"
                              type="text"
                              name="assistantEmail"
                              id="assistantEmail"
                              maxLength="45"
                              onChange={this.handleChange}
                              value={this.state.assistantEmail}
                              style={{ margin: "10px 0px", padding: "8px 16px" }}
                              placeholder='enter here' 
                            />
                            <label className="edit">Email</label>
                          </div>
                          {this.state.addAssistantModal && (
                            <>
                              <p style={{ textAlign: "left" }}>Please note that anyone you assign as an assistant will be able to:</p>
                              <ul style={{ textAlign: "left" }}>
                                <li>Add clients on your behalf, which will affect your balance</li>
                                <li>Order credits in bulk</li>
                                <li>Access sensitive personal information on clients</li>
                              </ul>
                              <p style={{ textAlign: "left" }}>
                                In setting them up as an assistant, you take full responsibility and liability for access and use of personal client data and for any actions by your assistant that will incur costs on your behalf.
                              </p>
                            </>
                          )}
                          <br />
                          <div style={{ textAlign: "left" }}>
                            <Button
                              variant="contained"
                              color="primary"
                              type="submit"
                              onClick={this.state.openEditModal ? this.updateAssistant : this.addAssistant}
                            >
                              Proceed
                            </Button>
                            <Button variant="contained" color="primary" type="button" onClick={this.closeModal}>
                              Cancel
                            </Button>
                          </div>
                        </div>
                      </Modal>
                      <Toast
                        level={this.state.level}
                        message={this.state.message}
                        visible={this.state.showToast}
                      />
                      <AlertModal
                        message={this.state.alertMessage}
                        modalTitle={this.state.alertModalTitle}
                        isOpen={this.state.openAlertModal}
                        showClose={(e) => this.state.closeModalCallback(e)}
                      />
                    </div>
                  </Paper>
                </Grid>
              </Grid>
            </Container>
            <LoadingBackdrop open={this.state.openBackdrop} />
          </main>
        </div>
      </>
    );
  }
}

// eslint-disable-next-line
export default (props) => {
  const classes = useStyles();
  return (
    <UserProfile classes={classes} {...props} />
  )
};